<template>
  <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
  <BaseHtmlForm
    ref="form"
    data-ignore-unsaved
    :action="action"
    method="POST"
    accept-charset="UTF-8"
    append-user-and-account
  >
    <WdsText large primary text="Would you classify the freelancer on this hire as a W-2 or as a contractor?"></WdsText>
    <WdsText secondary text="Selecting W-2 will set up the hire for payroll processing and incur additional employment costs."></WdsText>
    <br>

    <input
      v-model="employmentClasification"
      name="answers[employment_clasification]"
      type="hidden"
    />

    <button
      type="submit"
      class="btn btn-primary m-r-10"
      data-test="w2-hire-yes"
      @click.prevent="submit(true)"
    >
      W-2 hire
    </button>

    <button
      type="submit"
      class="btn btn-primary"
      data-test="w2-hire-no"
      @click.prevent="submit(false)"
    >
      Independent contractor
    </button>
  </BaseHtmlForm>
</template>

<script>
import { nextTick } from 'vue'
import { WdsText } from '@worksome/wds-components'

export default {
  components: { WdsText },

  props: {
    action: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      employmentClasification: 'none',
    }
  },

  methods: {
    submit(isTrue) {
      if (isTrue) {
        this.employmentClasification = 'w2'
      } else {
        this.employmentClasification = 'none'
      }

      nextTick(() => {
        this.$refs.form.submit()
      })
    },
  },
}
</script>
